import { render, staticRenderFns } from "./NewServiceDialog.vue?vue&type=template&id=c1574120&scoped=true&"
import script from "./NewServiceDialog.vue?vue&type=script&lang=js&"
export * from "./NewServiceDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewServiceDialog.vue?vue&type=style&index=0&id=c1574120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1574120",
  null
  
)

export default component.exports